import React from 'react';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { useSupporters } from '@gik/api/crm/supporters';
import { Supporters } from './Supporters';
import { HTMLParser, LoadingSpinner } from '@gik/ui';
import { useInkindStore } from '@gik/inkind/store/InkindStore';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '../../i18n/en';

export interface ISupportersPageContentProps {
  forceEmptyView?: boolean;
}

export const SupportersPageContent = ({ forceEmptyView }: ISupportersPageContentProps) => {
  const bem = useBemCN('supporters-page-content');
  const { t } = useTranslation();

  const inkindRouteId = useInkindStore(state => state.inkindRouteId);

  const { data: supporters } = useSupporters(inkindRouteId);

  const isLoading = !supporters;

  if (isLoading) return <LoadingSpinner center />;

  return (
    <div {...bem()}>
      <Supporters supporters={forceEmptyView ? [] : supporters} />

      <p {...bem('note')}>
        <HTMLParser rawHtml={t(translationKeys.supportersNote)} />
      </p>
    </div>
  );
};
